import { Component, Input, OnInit } from '@angular/core';
import { LegacyLabel } from '../inputs/common/legacy-label';

/**
 * Labeled data with lighter label and normal data
 */
@Component({
  selector: 'app-labeled-data-lighter',
  templateUrl: './labeled-data-lighter.component.html',
  styleUrls: ['./labeled-data-lighter.component.scss']
})
export class LabeledDataLighterComponent extends LegacyLabel implements OnInit {
  @Input() highlighted = false;
  @Input() error = false;
  @Input() twoLine = false;
  @Input() inline = false;
  @Input() labelColor: 'gray' | 'black' | 'primary' = 'gray';

  constructor() {
    super();
  }

  ngOnInit() {}
}
